module.exports = __webpack_public_path__ + "static/media/call.9b025971.svg";